module.exports = __webpack_public_path__ + "static/img/图层 8.7a904841.png";